module.exports = __webpack_public_path__ + "static/floating-action-button-icon-only-do-4e19b6db44842185a50aa03ecd155cd7.png";